// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SwitchContactCard Styles */

.scl--web-component-switch-contact-card-container {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  min-height: 486px;
  max-width: 350px;
  border: 1.5px solid #252525;
  border-radius: 10px;
}

.scl--web-component-switch-contact-content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 45px 30px;
  gap: 49px;
  width: 100%;
  height: auto;
  box-sizing: border-box;
}

.scl--web-component-switch-contact-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 26px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--web-component-switch-contact-item-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 26px;
  width: 100%;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--web-component-switch-contact-description {
  min-width: 100%;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 274;
  font-size: 18px;
  line-height: 1.4;
  color: #7D8187;
  margin: 0;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
}

.scl--web-component-switch-contact-button {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  gap: 11px;
  min-width: 139px;
  height: 40px;
  border: 1.5px solid #797979;
  border-radius: 20px;
  flex: none;
  order: 1;
  flex-grow: 0;
}

.scl--web-component-switch-contact-button .scl--web-component-round-button-text {
  height: 20px;
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #FFFFFF;
  flex: none;
  order: 0;
  flex-grow: 0;
}

`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/card/switch-contact/css/switchContactCard.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd","sourcesContent":["/* SwitchContactCard Styles */\n\n.scl--web-component-switch-contact-card-container {\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  min-height: 486px;\n  max-width: 350px;\n  border: 1.5px solid #252525;\n  border-radius: 10px;\n}\n\n.scl--web-component-switch-contact-content-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 45px 30px;\n  gap: 49px;\n  width: 100%;\n  height: auto;\n  box-sizing: border-box;\n}\n\n.scl--web-component-switch-contact-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 26px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--web-component-switch-contact-item-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 26px;\n  width: 100%;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--web-component-switch-contact-description {\n  min-width: 100%;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 274;\n  font-size: 18px;\n  line-height: 1.4;\n  color: #7D8187;\n  margin: 0;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.scl--web-component-switch-contact-button {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 16px 20px;\n  gap: 11px;\n  min-width: 139px;\n  height: 40px;\n  border: 1.5px solid #797979;\n  border-radius: 20px;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n.scl--web-component-switch-contact-button .scl--web-component-round-button-text {\n  height: 20px;\n  font-family: var(--primary-font);\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  color: #FFFFFF;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
